$(document).ready(function () {
    checkCookiesEnabled();
});
function checkCookiesEnabled() {
    // Vérifier si le test a déjà été effectué durant cette session
    if (sessionStorage.getItem('cookieTestDone') === 'true') {
        return; // Ne pas refaire le test
    }

    try {
        document.cookie = "cookieTest=1; SameSite=Lax";
        const cookiesEnabled = document.cookie.indexOf("cookieTest=") !== -1;
        document.cookie = "cookieTest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=Lax";

        // Marquer le test comme effectué
        sessionStorage.setItem('cookieTestDone', 'true');

        if (!cookiesEnabled) { // CORRECTION: rediriger si cookies DÉSACTIVÉS
            window.location.href = '/Login?handler=CookiesDisabled';
        }
    } catch (e) {
        sessionStorage.setItem('cookieTestDone', 'true');
    }
}
function closePopup() {
    var popupDiv = document.getElementById('ResetPasswordPopup');
    popupDiv.classList.toggle("pw-show");
    document.getElementById('BackFilter').style.display = 'none';
}



function switchShadow() {
    var popupElement = document.getElementById('ResetPasswordPopup');
    if (popupElement && popupElement.classList.contains("pw-show")) {
        document.getElementById('BackFilter').style.display = 'block';
    }
}

document.addEventListener('DOMContentLoaded', function () {
    switchShadow();

    var backicon = document.querySelector('.ribon-back-icon');
    var backtext = document.querySelector('.ribon-back-text');

    if (backicon) {
        var passwordField = document.querySelector('input[type="password"]');
        var isOnPasswordStep = passwordField !== null;

        function handleBack() {
            if (isOnPasswordStep) {
                // Return to email step, preserving the email value typed by the user
                var emailField = document.querySelector('#email-field');
                var email = emailField ? emailField.value.trim() : '';
                var url = window.location.pathname;
                if (email) {
                    url += '?email=' + encodeURIComponent(email);
                }
                window.location.href = url;
            } else {
                window.location.href = '/userselection';
            }
        }

        backtext.addEventListener('click', handleBack);
        backicon.addEventListener('click', handleBack);
    }
});